<template>
  <div>
    <div class="p-3 search-box-promo">
      <div class="wrap">
        <h3 class="medium">Thông tin Khuyến mãi đang được áp dụng</h3>
        <div class="description">
          Nhập <span class="text-success">BIN</span> hoặc <span class="text-success">số tiền thanh toán</span>(Loại thanh toán, Loại thẻ, Mô tả đơn hàng) để kiểm tra khuyến mãi đang áp dụng.(<a href="/promotion/budget">Khuyến mãi áp dụng</a>)
        </div>
        <div class="row g-2">
          <div class="col-6" v-if="merchantId == ''">
            <div class="form-floating mt-2">
              <input type="text" placeholder="Email MC" class="form-control" v-model="search.email" @input="search.email = search.email.trim()">
              <label>Email MC</label>
              <a class="close-text" v-if="search.email" @click="search.email = ''">
                <img src="@/assets/images/close-text.svg">
              </a>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating mt-2">
              <input type="text" placeholder="BIN" class="form-control" v-model="search.bin" @input="search.bin = search.bin.replace(/[^0-9]/g, '').trim()">
              <label>BIN(492236...)</label>
              <a class="close-text" v-if="search.bin" @click="search.bin = ''">
                <img src="@/assets/images/close-text.svg">
              </a>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating mt-2">
              <number type="tel" class="form-control" placeholder="Số tiền thanh toán" v-model.number="search.orderAmount" v-bind="{decimal: ',', separator: '.', prefix: '', precision: 0, masked: false, negative: false}" maxlength="12"></number>
              <label>Số tiền thanh toán</label>
              <a class="close-text" v-if="search.orderAmount" @click="search.orderAmount = '0'">
                <img src="@/assets/images/close-text.svg">
              </a>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating mt-2">
              <select placeholder="Loại thanh toán" class="form-control" v-model="search.paymentType">
                <option value="INSTALLMENT">INSTALLMENT</option>
                <option value="PAYNOW">PAYNOW</option>
              </select>
              <label>Loại thanh toán(INSTALLMENT/PAYNOW)</label>
              <a class="close-text" v-if="search.paymentType" @click="search.paymentType = 'INSTALLMENT'">
                <img src="@/assets/images/close-text.svg">
              </a>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating mt-2">
              <input type="tel" placeholder="Loại thẻ" class="form-control" v-model="search.cardSchema" @input="search.cardSchema = search.cardSchema.trim()">
              <label>Loại thẻ(VISA/MASTER/JCB...)</label>
              <a class="close-text" v-if="search.cardSchema" @click="search.cardSchema = 'VISA'">
                <img src="@/assets/images/close-text.svg">
              </a>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating mt-2">
              <input type="tel" placeholder="Mô tả đơn hàng" class="form-control" v-model="search.note" @input="search.note = search.note.trim()">
              <label>Mô tả đơn hàng(IPHONE17/...)</label>
              <a class="close-text" v-if="search.note" @click="search.note = ''">
                <img src="@/assets/images/close-text.svg">
              </a>
            </div>
          </div>
        </div>
        <div class="mt-4 text-message text-italic text-red" v-if="search.message">{{ search.message }}</div>
        <a class="btn btn-danger w-100 mt-3"  @click="btnCheckPromo">Kiểm tra</a>

        <div v-if="Object.keys(showPromo).length > 0">
            <div class="mt-3">
              <div><b>Chiến dịch:</b> {{showPromo.campaign_name}}</div>
            </div>
           <div class="showPromo">
              <div>
                <div class="logoPromo" v-if="showPromo.logo_url">
                  <img :src="showPromo.logo_url">
                </div>
                <div class="desPromo">{{showPromo.description}}</div>
              </div>
           </div>
            <div class="mt-2"><b>Số tiền chiết khấu:</b> {{formatNum(showPromo.amount_discount)}} VNĐ</div>
            <div>
              <div v-if="!showPromo.fee_force"><b>Phí:</b> theo cấu hình mặc định</div>
              <div v-else>
                <div v-if="showPromo.fee_pay_display && showPromo.fee_pay_user"><b>Phí quẹt thẻ:</b> khách hàng chịu(được tick/bỏ tick bởi thu ngân)</div>
                <div v-if="showPromo.fee_pay_display && !showPromo.fee_pay_user"><b>Phí quẹt thẻ:</b> MC chịu(được tick/bỏ tick bởi thu ngân)</div>
                <div v-if="!showPromo.fee_pay_display && !showPromo.fee_pay_user"><b>Phí quẹt thẻ:</b> MC chịu</div>
                <div v-if="!showPromo.fee_pay_display && showPromo.fee_pay_user"><b>Phí quẹt thẻ:</b> Khách hàng chịu</div>
                
                <div v-if="showPromo.fee_installment_display && showPromo.fee_installment_user"><b>Phí trả góp:</b> khách hàng chịu(được tick/bỏ tick bởi thu ngân)</div>
                <div v-if="showPromo.fee_installment_display && !showPromo.fee_installment_user"><b>Phí trả góp:</b> MC chịu(được tick/bỏ tick bởi thu ngân)</div>
                <div v-if="!showPromo.fee_installment_display && !showPromo.fee_installment_user"><b>Phí trả góp:</b> MC chịu</div>
                <div v-if="!showPromo.fee_installment_display && showPromo.fee_installment_user"><b>Phí trả góp:</b> Khách hàng chịu</div>
              </div>
            </div>
           <div class="text-message text-italic text-green" v-if="search.result">({{ search.result }})</div>
        </div>

      </div>
    </div>
    <section v-if="loading" class="ftco-section login-wap position-relative BE-regular ftco-section-loading">
          <div class="d-block text-center" style="margin-top:30vh">
            <div class="spinner-border text-danger" role="status">
                <span class="visually-hidden">{{ $t('text_31') }}</span>
            </div>
            <h3 class="d-block mt-3">{{ $t('text_31') }}</h3>
          </div>
        </section>
  </div>
</template>
<script>
import { PromotionService } from '@/services/promotion.service.js'
import { number } from '@coders-tm/vue-number-format'

export default {
  name: 'index',
  components: {
    number
  },
  data: () => {
    return {
      loading: false,
      error: '',
      merchantId: '',
      search: { merchantId: '', email: '', bin: '', orderAmount: 0, paymentType: 'INSTALLMENT', cardSchema: 'VISA', note: '', message: '', result: '' },
      showPromo: {}
    }
  },
  async created () {
    this.loading = true
    await this.decodeURI()
    this.loading = false
  },
  methods: {
    async decodeURI () {
      // const base64_encode = btoa('merchantId=1801')
      // https://domain.com/promotion/budget?params=bWVyY2hhbnRJZD0xODAx
      let params = (this.$route.query.params) ? this.$route.query.params : ''
      if (params !== '') {
        params = atob(params)
        params = params.split('&')
        if (params.length > 0) {
          params.forEach((item) => {
            if (item !== '') {
              const itemVal = item.split('=')
              if (itemVal.length === 2) {
                if (itemVal[0] === 'merchantId') {
                  this.merchantId = itemVal[1]
                  this.search.merchantId = itemVal[1]
                }
              }
            }
          })
        }
      }
    },
    formatNum (val) {
      if (val <= 0) {
        return val
      }
      val = val.toString().split('.').join('')
      let output = ''
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length)
        val = val.slice(0, val.length - 3)
        output = '.' + last3Digits + output
      }
      if (val.length === 0) {
        output = output.slice(1, output.length)
      } else {
        output = val + output
      }
      return output
    },
    validateEmail () {
      if (!this.search.email) {
        this.search.message = 'Vui lòng nhập email!'
        return false
      }
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!regex.test(this.search.email)) {
        this.search.message = 'Email không hợp lệ!'
        return false
      }
      this.search.message = ''
      return true
    },
    async btnCheckPromo () {
      try {
        if (this.merchantId === '' && (this.search.email !== '' || this.search.email === '')) {
          if (!this.validateEmail()) {
            return false
          }
        }
        this.loading = true
        this.showPromo = {}
        if (this.search.email !== '') {
          const params = { email: this.search.email, phone_number: this.search.phone, items_per_page: 1, page: 1 }
          const response = await PromotionService.getMerchantPromo(params)
          if (response.errorCode === '00') {
            const mc_id = response?.data?.data?.List?.data?.[0]?.mc_id
            if (mc_id !== undefined) {
              this.search.merchantId = String(mc_id)
            } else {
              this.loading = false
              this.search.message = 'MC không tồn tại!'
              return false
            }
          } else {
            this.loading = false
            this.search.message = 'MC không tồn tại!'
            return false
          }
        }
        this.loading = false
        if (this.search.merchantId === '') {
          return false
        }
        const paramsCheck = {
          payment_info: {
            bin: this.search.bin,
            card_schema: this.search.cardSchema,
            payment_type: this.search.paymentType,
            note: this.search.note
          },
          merchant_info: {
            merchant_id: this.search.merchantId,
            name: 'NGUYEN VAN A',
            phone: '0912345678',
            email: this.search.email
          },
          order_info: {
            order_amount: parseInt(this.search.orderAmount)
          },
          udid: 'QUET_THE_b74d4d80-3204-11f0-b882-db55086806fe-' + this.search.merchantId
        }
        const responseCheck = await PromotionService.getPromoCheck(paramsCheck)
        if (responseCheck.errorCode === '00') {
          const showPromo = responseCheck?.data?.promotion_info
          if (showPromo !== undefined) {
            this.showPromo = showPromo
            this.search.result = 'Khuyến mãi được áp dụng'
            return false
          } else {
            this.search.message = 'Chương trình khuyến mãi đã kết thúc hoặc chưa diễn ra!'
            return false
          }
        } else {
          this.search.message = 'Chương trình khuyến mãi đã kết thúc hoặc chưa diễn ra!'
          return false
        }
      } catch (error) {
        this.search.message = 'Có lỗi xảy ra. Vui lòng thử lại sau!'
        return false
      }
    }
  }
}
</script>
<style>
body{background-color:#E9E9EA!important}.search-box-promo{background:#fff;overflow:hidden;border-bottom:1px solid #ddd}.search-box-promo .medium{font-size:20px;margin-bottom:16px}.search-box-promo .description{font-size:16px;color:#6c757d;width:100%;display:inline-block}.search-box-promo .btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545;padding:.5rem .8rem}.search-box-promo .form-control:focus{outline:0!important;box-shadow:none!important;border:1px solid #ddd!important}.text-red{color:#ff0000}.text-green{color:#08A045}.text-italic{font-style:italic}.desPromo,.logoPromo{display:inline-block;float:left}.showPromo{border:1px solid #ddd;padding:2px 5px;background:#ddd;border-radius:5px;width:100%;display:inline-block;margin-top:12px}.logoPromo{width:30px;margin-right:2px}.desPromo{max-width:70%;margin-top:2px}.logoPromo img{width: 100% !important;}
</style>
